namespace TabAurous.OMS {
    export interface HSNTaxDetailsRow {
        DetailsId?: number;
        Code?: string;
        TaxId?: number;
        TaxName?: string;
        TaxRate?: number;
        IsInterState?: boolean;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        GroupId?: number;
    }

    export namespace HSNTaxDetailsRow {
        export const idProperty = 'DetailsId';
        export const localTextPrefix = 'OMS.HSNTaxDetails';
        export const lookupKey = 'OMS.HSNTaxDetails';

        export function getLookup(): Q.Lookup<HSNTaxDetailsRow> {
            return Q.getLookup<HSNTaxDetailsRow>('OMS.HSNTaxDetails');
        }
        export const deletePermission = 'Masters:HSN:Delete';
        export const insertPermission = 'Masters:HSN:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:HSN:Edit';

        export declare const enum Fields {
            DetailsId = "DetailsId",
            Code = "Code",
            TaxId = "TaxId",
            TaxName = "TaxName",
            TaxRate = "TaxRate",
            IsInterState = "IsInterState",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            GroupId = "GroupId"
        }
    }
}
